import Vue from 'vue'
import { login } from '@zz-zlj-common/h5-miniprogram-tools'
import { nativeIsLogin } from '@/utils/native'
export default async(callback, context = null, isInvalidToken = false) => {
  if (callback && context) {
    callback = callback.bind(context)
  }
  console.log(callback, nativeIsLogin(), nativeIsLogin() && !isInvalidToken, 'callback1')
  // isInvalidToken 无效token需要重新调起登录
  if (nativeIsLogin() && !isInvalidToken) {
    console.log(callback, 'callback2')
    callback && callback()
  } else {
    login({
      callback(res) {
        console.log(res, '回调后的结果', callback)
        Vue.prototype.$bus.set('userInfo', res)
        callback && callback()
      },
      context,
      isInvalidToken
    })
  }
}
